<template>
    <div class="leftO">
        <div class="leaderBox" v-if="showOrhide">
            <img src="../../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
            <img src="../../../assets/images/baojia1.png" class="steps step1" v-if="status==1">
            <img src="../../../assets/images/baojia3.png" class="steps step2" v-if="status==2">
            <div class="stepbtn" @click="nextStep(status)">
                {{status==1?"下一步":status==2?"我知道了":"我知道了"}}
            </div>
            <div class="bottomTip">
                <el-checkbox v-model="checked">下次不再提示</el-checkbox>
            </div>
        </div>
        <breadcrumb :routerList="[{to:'/xiangmu/pm',title:'项目管理'},{title:'提交报价'}]"/>
        <div style="margin:20px">
            <div class="h-row h-mrt0" style="margin:0 -0.12rem ;">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                    <h1>询价产品信息</h1>
                                </div>
                                <div style="display: flex;margin-bottom:0.2rem">
                                    <div class="left4" style="width: 50%">
                                        <span>项目编号</span>
                                        <span class="spanT">{{formLabelAlign.id}}</span>
                                    </div>
                                    <div class="left4" style="margin-left: 0.38rem;width: 50%">
                                        <span>项目名称</span>
                                        <span class="spanT">{{formLabelAlign.projectName}}</span>
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>
                    <el-table
                            @selection-change="handleSelectionChange"
                            ref="multipleTable"
                            :data="proProductwx"
							:border="true"
                            style="width: 100%;margin-top: 0.2rem">
                        <el-table-column
                                type="selection"
                                width="70"
                                :label="all"
                                @header-click="headerClick"
                        >
                        </el-table-column>
                        <el-table-column
                                type="index"
                                width="40"
                                label="#">
                        </el-table-column>
                        <el-table-column
                                prop="typeName"
                                min-width="90"
                                label="产品大类">
                        </el-table-column>

                        <el-table-column
                                prop="productName"
                                label="产品型号"
                                min-width="150"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="productDes"
                                label="产品描述"
                                min-width="150"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="unitPrice"
                                label="报价"
                                min-width="150"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.unitPrice" placeholder="请输入"
                                          class="h-tableInput"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="priceTerm"
                                label="报价有效期"
                                min-width="150"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <el-date-picker
                                        v-model="scope.row.priceTerm"
                                        type="date"
                                        :picker-options="pickerOptions"
                                        placeholder="选择日期">
                                </el-date-picker>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop=""
                                label="查看历史报价"
                                min-width="150"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <el-button
                                        type="text"
                                        size="small"
                                        class="h-tableLink h-btn"
                                        @click="seeDetail(scope.row)"
                                >查看
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
        <div style="display: flex;justify-content: center;align-items: center;margin-top: 0.5rem;">
            <el-button class="el-button h-btn h-bBtn h-bgwhite" style="border: #fff" @click="goBack">返回</el-button>
            <el-button class="el-button h-btn h-bBtn h-bgblueQ2 el-button--default" @click="commitBaojia">提交</el-button>
        </div>
        <el-dialog :close-on-click-modal="false" :visible.sync="dialogTableVisible" class="h-dialog2">
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>查看历史报价</h1>
                    </div>
                </div>
            </div>
            <div class="h-formLines" style="padding:30px 48px;">
                <el-table
                        :data="gridData"
						:border="true"
                        style="width: 100%">
                    <el-table-column
                            type="index"
                            width="40"
                            label="#">
                    </el-table-column>
                    <el-table-column
                            prop="supplierPrice"
                            label="报价"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            prop="supplierTime"
                            label="时间">
                    </el-table-column>
                </el-table>
            </div>
            <div style="display:flex;justify-content:center">
                <el-button class="h-btn h-formBtn" @click="dialogTableVisible=false" type="primary">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService';

    export default {
        data() {
            return {
                projectId: '',
                gridData: [],
                dialogTableVisible: false,
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
                    }
                },
                checked: true,
                toshow: 'commit',
                showOrhide: false,
                status: 1,
                formLabelAlign: {},
                proProductwx: [],
                commitBaojiaData:{
                    taskid: '',
                    inquiryId: '',
                    productList: [],
                },
                proPriceOffer: {},
                subflag: 0,
                rules: {
                    unitPrice: [{required: true, message: '请输入数字', trigger: 'blur'},
                        {pattern: /^[1-9]d*|0$/, message: '只能输入正整数'}],
                    supplierPrice: [{required: true, message: '请输入数字', trigger: 'blur'},
                        {pattern: /^[1-9]d*|0$/, message: '只能输入正整数'}],
                }
            }
        },
        methods: {
            queryProjectId(){
                ss.ProService.queryProjectId(this.$route.query.ywid).then(res => {
                    if (res != null){
                        this.projectId = res;
                        // 查到projectid之后再调用本来该调用的方法
                        this.query();
                        this.getProdectList();
                    }
                })
            },
            seeDetail(v){
                ss.ProService.seeHistory(this.$route.query.inquiryId,v.id).then(res => {
                    console.log(res,'历史报价')
                    this.gridData = res;
                    this.dialogTableVisible = true;
                })

            },
            goBack() {
                this.$router.push("/xiangmu/pmgys");
            },
            commitBaojia() {
                if(this.$route.query.inquiryId){
                    this.commitBaojiaData.inquiryId = this.$route.query.inquiryId;
                }else{
                    this.commitBaojiaData.inquiryId = this.$route.query.ywid;
                }
                this.commitBaojiaData.productList = this.proProductwx;
                this.$confirm('是否确认提交报价?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    if (this.$route.query.taskid != undefined){
                        this.commitBaojiaData.taskid = this.$route.query.taskid;
                    }
                    ss.ProService.commitBaojia(this.commitBaojiaData).then(res => {
                        if (res.f){
                            this.$message({
                                type: 'success',
                                message: '提交成功!'
                            });
                            this.$router.push("/xiangmu/pmgys")
                        }
                    })

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消提交'
                    });
                });

            },
            getProdectList() {
                var id = this.$route.query.ywid ? this.projectId : this.$route.query.id
                ss.ProService.getProdectList(id).then(res => {
                    console.log(res, '产品列表')
                    this.proProductwx = res;
                })
            },
            closeIt() {
                this.showOrhide = false;
                if (this.checked) {
                    sessionStorage.leader8 = '3';
					ss.salesList.toshow(this.toshow, this.checked).then(rd => {
					    if (rd == false) {
					        this.showOrhide = false;
					    } else {
					        this.showOrhide = true
					    }
					})
                }
            },
            nextStep(i) {
                console.log(i)
                if (this.status == 1) {
                    if (this.checked) {
                        sessionStorage.leader8 = '2';
                        this.status = 2;
						document.documentElement.scrollTop = 400;
                    }else{
						sessionStorage.leader8 = '2';
						this.status = 2;
						document.documentElement.scrollTop = 400;
					}
                } else if (this.status == 2) {
                    if (this.checked) {
                        sessionStorage.leader8 = '3';
                        this.status = 3;
						ss.salesList.toshow(this.toshow, this.checked).then(rd => {
						    if (rd == false) {
						        this.showOrhide = false;
						    } else {
						        this.showOrhide = true
						    }
						})
                    }else{
						sessionStorage.leader8 = '3';
						this.status = 3;
						 this.showOrhide = false;
					}
                    

                }
            },
            onSubmit() {
                console.log('submit!');
            },
            // query() {
            //     console.log(this.$route.query.ywid, "id");
            //     var id = this.$route.query.ywid ? this.$route.query.ywid : this.$route.query.id
            //     ss.ProService.proDetailOffer(id).then(rd => {
            //         console.log(rd, "项目详情");
            //         if (rd.proPriceOfferList && rd.proPriceOfferList.length > 0) {
            //             this.formLabelAlign = rd;
            //             //产品信息赋值
            //             this.proProductwx = rd.proProductInfoList[0];
            //             this.proPriceOffer = rd.proPriceOfferList[0];
            //             if (!this.proPriceOffer.supplierPrice) {
            //                 //没有报过价时可以提交，有报价信息后只能返回
            //                 this.subflag = 1;
            //             } else {
            //                 this.subflag = 2;
            //             }
            //             console.log("this.proPriceOffer=", this.proPriceOffer);
            //         } else {
            //             this.$msg.msge("只能供应商自己报价");
            //             if (this.$route.query.taskid) {
            //                 this.$router.push("/personal/dealCenter");
            //             } else {
            //                 this.$router.push("/xiangmu/pm");
            //             }
            //         }
            //     });
            // },
            query() {
                // console.log(this.$route.query.ywid, "id");
                var id = this.$route.query.ywid ? this.projectId : this.$route.query.id
                ss.ProService.proDetailOffer(id).then(rd => {
                    console.log(rd, "项目详情");
                    this.formLabelAlign = rd;
                });
            },
            cancelPro() {
                this.$router.push("/xiangmu/pmgys");
            },
            submitPro() {
                var subflag = false;
                this.$refs['proPriceOffer'].validate((valid) => {
                    if (valid) {
                        subflag = true;
                    } else {
                        this.$msg.msge("请正确填写报价后再提交！");
                        return false;
                    }
                });
                console.log(subflag);
                if (subflag) {
                    this.$msg.confirm("确认提交报价，提交后将不能再修改?", () => {
                        this.proPriceOffer.taskid = this.$route.query.taskid;
                        console.log(this.proPriceOffer);
                        ss.ProService.saveOffer(this.proPriceOffer).then(rd => {
                            this.$store.dispatch('searchTasktotal');
                            this.$msg.alerts("提交成功！", () => {
                                if (this.$route.query.taskid) {
                                    this.$router.push("/personal/dealCenter");
                                } else {
                                    this.$router.push("/xiangmu/pmgys");
                                }
                            })
                        })
                    })
                }
            },
        },
        created() {

        },
        mounted() {
            // 非审批进入
            if (this.$route.query.taskid == undefined){
                this.query();
                this.getProdectList();
            }else {
                this.queryProjectId();
            }

            this.status = sessionStorage.leader8 ? sessionStorage.leader8 : 1;
            console.log(this.status)
            if (sessionStorage.leader8 != 3) {
                this.showOrhide = true;
            }
        }
    }
</script>
<style scoped>
    .outcontain {
        display: flex;
        justify-content: space-around;
        margin-top: 0.3rem;
        padding-left: 0.3rem;
    }

    .left {
        width: 30%;
        background-color: rgb(255, 255, 255);
        height: 600px;
        border: 1px solid #E2E2E2;
    }

    .left3 {
        margin-left: 30px;
        margin-top: 20px;
    }

    .left4 span{
        font-size: 0.18rem;
        color: #4a4a4a;
        line-height: 0.28rem;
    }

    .spanT {
        margin-left: 20px;
        color: rgb(141, 140, 140);
    }

    .spanG {
        color: rgb(141, 140, 140);
    }

    hr {
        margin-top: 10px;
        height: 1px;
        background-color: rgb(222, 226, 226);
        margin-right: 20px;
    }

    .hr {
        margin-top: 20px;
    }

    hr.border {
        border: none;
    }

    .zhongbiao {
        position: relative;
        left: 15px;
    }

    .zhongbiao > div {
        padding: 5px 0;
    }

    .leftO .left .left3 .zhongbiao .el-button {
        position: relative;
        left: 90px;
        padding: 5px 10px;
        top: 25px;
        border: none;
        background-color: #d6f2e1;
        color: #34b174;
        border-radius: 6px;
    }

    span {
        font-size: 14px;
    }

    .xunjia {
        padding-top: 20px;
    }

    .right {
        width: 63%;
        height: 600px;
        background-color: rgb(255, 255, 255);
        border: 1px solid #E2E2E2;
    }

    .baojia {
        margin: 0 50px;
        padding-top: 20px;
    }

    .el-form {
        margin: 70px 0 20px 55px;
    }

    .el-form-item {
        margin-bottom: 60px;
    }

    .enter {
        margin-top: 2rem;
        display: flex;
        justify-content: center;
    }

</style>

<style>
    .h-formbLine2 .el-form-item__label {
        width: 30% !important;
    }

    .h-formbLine2 .el-form-item__content {
        width: 70% !important;
    }
</style>
<style scoped lang="scss">
    .bottomTip {
        position: absolute;
        left: 49.7%;
        bottom: 0.3rem;
        transform: translateX(-50%);
    }

    .newtext {
        font-size: 0.28rem;
        color: white;
        position: absolute;
        top: 0.2rem;
        left: 0.6rem;
        font-weight: bold;
        text-shadow: 1px 1px 4px #2785E7;;
    }

    .leaderBox {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        position: fixed;
        z-index: 99999;
        overflow: hidden;
        top: 0;
        left: 0;

        .leaderbg {
            width: 100%;
            height: 100%;

        }

        .steps {
            position: absolute;
            z-index: 1;

        }

        .step1 {
            top: 3rem;
            right: 3.8rem;
            width: 6.3rem;
            height: 2.1rem;
        }

        .step2 {
            top: 2.8rem;
            right: 0.6rem;
            width: 5rem;
            height: 1.5rem;
        }

        .stepbtn {
            width: 1.9rem;
            height: 0.6rem;
            border: 0.03rem solid #FFFFFF;
            background-color: rgba(0, 0, 0, 0.1);
            border-radius: 5px;
            display: flex;
            justify-content: center;
            line-height: 0.5rem;
            position: absolute;
            z-index: 99;
            bottom: 0.75rem;
            left: 50%;
            transform: translateX(-50%);
            font-size: 0.27rem;
            letter-spacing: 2px;
            color: white;
            cursor: pointer;
        }

        .closeIt {
            width: 0.3rem;
            height: 0.3rem;
            position: absolute;
            top: 0.2rem;
            right: 0.2rem;
            cursor: pointer;
        }
    }
</style>


